import { DialogWithForm } from '@strata/react-dialog';
import { TextInputFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { usePostCreateNotebookMutation } from 'store/api/intakeCaseApi';

const ValidationSchema = Yup.object({
    subject: Yup.string().required(validationStrings.requiredField.errorMessage),
});

interface NewNotebookDialogProps {
    isOpen: boolean;
    intakeCaseId: string;
    onCreateSuccess: (newNotebookId: string) => void;
    onCancel: () => void;
}

export const NewNotebookDialog = ({
    isOpen,
    intakeCaseId,
    onCreateSuccess,
    onCancel,
}: NewNotebookDialogProps) => {
    const [postCreateNotebook] = usePostCreateNotebookMutation();
    return (
        <Formik
            initialValues={{} as Yup.InferType<typeof ValidationSchema>}
            validationSchema={ValidationSchema}
            enableReinitialize
            onSubmit={async ({ subject }, { resetForm }) => {
                const newNotebookId = await postCreateNotebook({
                    intakeCaseId,
                    details: { subject },
                }).unwrap();
                SuccessToast({ message: 'Notebook created successfully.' });
                onCreateSuccess(newNotebookId);
                resetForm();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    isOpen={isOpen}
                    dialogTitle="Create Notebook"
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    onSecondaryButtonClick={() => {
                        onCancel();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Create Notebook"
                    secondaryButtonLabel="Cancel"
                    dialogContent={<TextInputFormik id="subject" label="Notebook Title" required />}
                />
            )}
        </Formik>
    );
};
